import { GridColDef } from "@mui/x-data-grid";
import { useTranslation } from "react-i18next";
import { TbClock } from "react-icons/tb";

import { TableHeader } from "@/components/TableHeader";
import { dayAgo } from "@/helpers/date";
import { WeTrackVehicleData } from "@/types/wetrack.types";

export const LastUpdateDate = (): GridColDef<WeTrackVehicleData["properties"]> => {
    return {
        field: "last_signal",
        headerName: "lastUpdateTime",
        minWidth: 150,
        type: "number",
        renderHeader: (params) => <TableHeader Component={TbClock} title={params.colDef.headerName!} />,
        renderCell: (params) => {
            const { i18n } = useTranslation();

            return (
                <div className="flex p-1 items-center font-medium h-full gap-1  text-xs">
                    {dayAgo(params.row.last_signal, i18n.language)}
                </div>
            );
        },
    };
};
